/**
 * Features for product type general.
 */
export enum LicenseGeneralFeature {
  CHILDREN_MANAGEMENT = 'children_management',
  GENERAL_SUPPORT = 'general_support',
  QR_CHILD_LOGIN = 'qr_child_login',
  CHILD_TRANS_CODE = 'child_trans_code',
  SHARE_RESULT_PARENT = 'share_result_parent',
  TEACHER_GROWTH = 'teacher_growth',
  MENU_SMART = 'menu_smart',
  MENU_MANAGEMENT = 'menu_management',
  SHOW_PRODUCTS = 'show_products',
  DASHBOARD_SK = 'dashboard_sk',
  DASHBOARD_SCHOOL = 'dashboard_school',
  TESTING = 'testing',
  MENU_PORTFOLIO = 'menu_portfolio',
  SHOWCASE = 'showcase',
  TRIAL = 'trial',
  TEST_KIT = 'test_kit',
  MENU_DIAGNOSTICS = 'menu_diag',
  REPORT_TRANSITION = 'report_transition',
  EXTRA_MATERIALS = 'extra_materials',
}
